import { Badge } from "@/components/ui/badge";

const TONE_MAP: Record<string, "neutral" | "success" | "warning" | "danger" | "accent"> = {
  pending: "warning",
  open: "warning",
  in_progress: "accent",
  resolved: "success",
  closed: "neutral",
  archived: "neutral",
  failed: "danger",
};

export function StatusBadge({ status }: { status: string | null | undefined }) {
  if (!status) return <Badge tone="neutral">unknown</Badge>;
  const key = String(status).toLowerCase().replace(/[\s-]/g, "_");
  const tone = TONE_MAP[key] ?? "neutral";
  return <Badge tone={tone}>{status}</Badge>;
}
